import { Module } from 'vuex'

export const createModule = <S, R>(options: Module<S, R>) => <Module<S, R>>options

export type Modules = Record<string, Module<any, any>>
